import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import styles from "../styles.module.scss";
import httpService from "Root/api/httpService";
import { MenuItem, Select, TextField } from "@mui/material";
import cx from "classnames";
import Button from "../../common/Button";
import { MACROS_KEY, safeGetItem } from "..";
import { isMobile } from "Helpers/device";
import DrawerComponent from "../../common/DrawerComponent";
import RdMacroToolComponent from "./MacroCalculator";
import posthog from "posthog-js";
import toastService from "Root/profile/toastService";
import { useDispatch } from "react-redux";
import { setGlobalLoading } from "Root/profile/redux/actionCreators/makeActionCreator";
function formatNumberWithCommas(number) {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
const CheckboxGroup = ({ checkboxes, setCheckboxes }) => {
    const handleCheckboxChange = (id) => {
        const updatedCheckboxes = checkboxes.map((checkbox) => checkbox.id === id
            ? { ...checkbox, isChecked: !checkbox.isChecked }
            : checkbox);
        setCheckboxes(updatedCheckboxes);
    };
    return (_jsx("div", { className: styles.checkboxGroup, children: checkboxes.map((checkbox) => (_jsxs("label", { children: [_jsx("div", { className: cx(styles.newCheckmarkBox, {
                        [styles.checked]: checkbox.isChecked,
                    }), role: "checkbox", "aria-checked": checkbox.isChecked, children: _jsx("svg", { className: styles.checkmark, xmlns: "http://www.w3.org/2000/svg", width: "21", height: "20", viewBox: "0 0 21 20", fill: "none", children: _jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.2232 6.23741C15.5707 6.57449 15.5942 7.14584 15.2756 7.51356L9.90976 13.7071C9.75243 13.8887 9.53181 13.9944 9.29903 13.9998C9.06625 14.0051 8.8415 13.9097 8.67686 13.7355L5.75003 10.6387C5.41666 10.2859 5.41666 9.71406 5.75003 9.36133C6.0834 9.00859 6.62391 9.00859 6.95729 9.36133L9.25367 11.791L14.0171 6.2929C14.3356 5.92518 14.8756 5.90034 15.2232 6.23741Z", fill: "white" }) }) }), _jsx("input", { className: styles.checkbox, type: "checkbox", checked: checkbox.isChecked, onChange: () => handleCheckboxChange(checkbox.id) }), checkbox.label] }, checkbox.id))) }));
};
const MacroCalculatorForm = ({ setResponse, RESPONSE_KEY, profileId }) => {
    const storedResponses = safeGetItem(MACROS_KEY, {});
    const s = storedResponses;
    const [calories, setCalories] = useState(s.calories || 2000);
    const [gramsFat, setGramsFat] = useState(s.gramsFat || 67);
    const [gramsProtein, setGramsProtein] = useState(s.gramsProtein || 150);
    const [gramsCarbs, setGramsCarbs] = useState(s.gramsCarbs || 200);
    const [percFat, setPercFat] = useState(s.percFat || 34);
    const [percProtein, setPercProtein] = useState(s.percProtein || 30);
    const [percCarbs, setPercCarbs] = useState(s.percCarbs || 36);
    const [usePerc, setUsePerc] = useState(s.usePerc || false);
    const [caloriesFromMacros, setCaloriesFromMacros] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    // const [error, setError] = useState("");
    const [checkboxes, setCheckboxes] = useState(s.checkboxes || [
        { id: "eggs", label: "Eggs", isChecked: false },
        { id: "milk", label: "Milk", isChecked: false },
        { id: "nuts", label: "Nuts", isChecked: false },
        { id: "peanuts", label: "Peanuts", isChecked: false },
        { id: "shellfish", label: "Shellfish", isChecked: false },
        { id: "wheat", label: "Wheat", isChecked: false },
        { id: "gluten", label: "Gluten", isChecked: false },
        { id: "soy", label: "Soy", isChecked: false },
        { id: "fish", label: "Fish", isChecked: false },
        { id: "sesame", label: "Sesame", isChecked: false },
    ]);
    const [diet, setDiet] = useState(s.diet || "normal");
    const dispatch = useDispatch();
    const onSubmit = async (e) => {
        posthog.capture("generate_meal_plan");
        e.preventDefault();
        // submit form data to API
        if (percCarbs + percFat + percProtein !== 100) {
            // setError("Macro percentages must add up to 100%");
            toastService.errorMessage("Macro percentages must add up to 100%");
            return;
        }
        else {
            // setError("");
        }
        const savedInputs = {
            calories,
            gramsFat,
            gramsProtein,
            gramsCarbs,
            allergies: checkboxes,
            diet,
            percFat,
            percCarbs,
            percProtein,
            usePerc,
        };
        const protein_g = usePerc
            ? calories * (percProtein / 100 / 4)
            : gramsProtein;
        const fat_g = usePerc ? calories * (percFat / 100 / 9) : gramsFat;
        const net_carbs_g = usePerc ? calories * (percCarbs / 100 / 4) : gramsCarbs;
        const requestBody = {
            protein_g,
            fat_g,
            net_carbs_g,
            calories: usePerc ? calories : caloriesFromMacros,
            allergies: checkboxes
                .filter((checkbox) => checkbox.isChecked)
                .map((checkbox) => checkbox.id)
                .join(","),
            diet,
        };
        const maxTries = 3;
        let counter = 0;
        setIsLoading(true);
        dispatch(setGlobalLoading(true));
        let results = await httpService.post("/users/get-meal-plan/", requestBody);
        while (results.success === false && counter < maxTries) {
            counter += 1;
            if (counter === maxTries) {
                // let the backend know this is the final attempt
                // so it can create a zendesk ticket for RD if it fails
                requestBody.final = true;
            }
            // this rules exists to prevent multiple requests from blocking each other
            // but we WANT the requests to block each other
            // eslint-disable-next-line no-await-in-loop
            results = await httpService.post("/users/get-meal-plan/", requestBody);
        }
        dispatch(setGlobalLoading(false));
        if (results.success === false) {
            toastService.errorMessage("Looks like we cannot generate a meal plan for your specific macro targets. An RD has been notified and will reach out soon.", 6000);
            posthog.capture("meal_plan_error", savedInputs);
        }
        else {
            posthog.capture("meal_plan_success", savedInputs);
            setResponse(results);
            localStorage.setItem(MACROS_KEY, JSON.stringify(savedInputs));
            localStorage.setItem(RESPONSE_KEY, JSON.stringify(results));
            location.href = "/app/my-meal-plan";
        }
    };
    useEffect(() => {
        setCaloriesFromMacros(gramsFat * 9 + gramsProtein * 4 + gramsCarbs * 4);
    }, [gramsFat, gramsProtein, gramsCarbs]);
    const [calculatorIsOpen, setCalculatorIsOpen] = useState(false);
    const useStoredValues = (vals) => {
        const newVals = {
            calories: vals.calories,
            gramsCarbs: vals.carbs,
            gramsFat: vals.fat,
            gramsProtein: vals.protein,
            percCarbs: Math.floor(vals.carb_percent * 100),
            percFat: Math.floor(vals.fat_percent * 100),
            percProtein: Math.floor(vals.protein_percent * 100),
        };
        const oldVals = safeGetItem(MACROS_KEY, {});
        const s1 = { ...oldVals, ...newVals };
        const percProteinRevised = 100 - s1.percCarbs - s1.percFat;
        s1.percProtein = percProteinRevised;
        localStorage.setItem(MACROS_KEY, JSON.stringify(s1));
        setCalories(s1.calories);
        setGramsFat(s1.gramsFat);
        setGramsProtein(s1.gramsProtein);
        setGramsCarbs(s1.gramsCarbs);
        setPercFat(s1.percFat);
        setPercCarbs(s1.percCarbs);
        setPercProtein(percProteinRevised);
        setUsePerc(s1.usePerc);
        setDiet(s1.diet);
    };
    const closeModal = (vals) => {
        setCalculatorIsOpen(false);
        useStoredValues(vals);
    };
    return (_jsxs("div", { className: styles.calculatorContainer, children: [_jsx("h2", { className: styles.subhed, children: "Based On Your Macronutrients" }), _jsxs("div", { style: { margin: "0 auto 32px", textAlign: "center" }, children: [_jsx(Button, { variant: "secondary", underlined: true, onClick: () => setCalculatorIsOpen(true), children: "Calculate My Macros" }), _jsx(DrawerComponent, { crossButton: true, open: calculatorIsOpen, toggleDrawer: (val) => () => setCalculatorIsOpen(val), anchor: isMobile() ? "bottom" : "right", children: _jsx(RdMacroToolComponent, { closeModal: closeModal }) })] }), _jsxs("div", { className: styles.chooser, children: [_jsx("button", { onClick: () => setUsePerc(false), className: cx({ [styles.active]: !usePerc }), children: "Use grams" }), _jsx("button", { onClick: () => setUsePerc(true), className: cx({ [styles.active]: usePerc }), children: "Use percent" })] }), usePerc ? (_jsxs(_Fragment, { children: [_jsx("div", { className: styles.percentDisclaimer, children: _jsxs("div", { children: ["Percents must add up to 100. Currently:", " ", percCarbs + percFat + percProtein, "%"] }) }), _jsxs("div", { className: styles.macroInputContainer, children: [_jsx(TextField, { label: "Calories", type: "number", value: calories, onChange: (e) => {
                                    setCalories(parseInt(e.target.value));
                                } }), _jsx(TextField, { label: "Carbs (%)", type: "number", value: percCarbs, onChange: (e) => {
                                    setPercCarbs(parseInt(e.target.value));
                                } }), _jsx(TextField, { label: "Fat (%)", type: "number", value: percFat, onChange: (e) => {
                                    setPercFat(parseInt(e.target.value));
                                } }), _jsx(TextField, { label: "Protein (%)", type: "number", value: percProtein, onChange: (e) => {
                                    setPercProtein(parseInt(e.target.value));
                                } })] })] })) : (_jsxs(_Fragment, { children: [_jsxs("div", { className: styles.caloriesContainer, children: [_jsx("div", { className: styles.caloriesCopy, children: "Total calories" }), _jsxs("div", { className: styles.caloriesNumber, children: [" ", formatNumberWithCommas(caloriesFromMacros)] })] }), _jsxs("div", { className: styles.macroInputContainer, children: [_jsx(TextField, { label: "Carbs (grams)", type: "number", value: gramsCarbs, onChange: (e) => {
                                    setGramsCarbs(parseInt(e.target.value));
                                } }), _jsx(TextField, { label: "Fat (grams)", type: "number", value: gramsFat, onChange: (e) => {
                                    setGramsFat(parseInt(e.target.value));
                                } }), _jsx(TextField, { label: "Protein (grams)", type: "number", value: gramsProtein, onChange: (e) => {
                                    setGramsProtein(parseInt(e.target.value));
                                } })] })] })), _jsx("h2", { className: styles.allergensHed, children: "Allergens" }), _jsx(CheckboxGroup, { checkboxes: checkboxes, setCheckboxes: setCheckboxes }), _jsx("h2", { className: styles.allergensHed, children: "Dietary Preferences" }), _jsxs(Select, { id: "demo-simple-select", value: diet, onChange: (e) => setDiet(e.target.value), style: {
                    width: "100%",
                }, className: styles.dropdown, children: [_jsx(MenuItem, { value: "normal", children: "No Restrictions" }), _jsx(MenuItem, { value: "vegetarian", children: "Vegetarian" }), _jsx(MenuItem, { value: "vegan", children: "Plant-based/vegan" })] }), _jsx("div", { className: styles.stickyFooter, children: _jsx(Button, { color: "court", onClick: onSubmit, children: "Generate my meal plan" }) }), _jsx("br", {})] }));
};
export default MacroCalculatorForm;
